module.exports = __webpack_public_path__ + "media/img/marquee/marquee-products-c4408f162b9b25796f6115bcc7bdc774.jpg";